<div class="galeria galeria-one {{classCustom}}" data-pswp-uid="1" #galeria itemscope itemtype="https://schema.org/ImageGallery">
  <a class="animated fadeIn" *ngFor="let foto of fotos" [href]="foto.imagem" [title]="foto.titulo" data-size="800x494" data-med-size="800x494">
    <img itemprop="image" [src]="foto.imagem" [alt]="foto.alt" />
    <figure>{{foto.titulo}}</figure>  
  </a>  
</div>
<pswp-template></pswp-template>
